import React, { Fragment } from 'react';
import { Redirect, useRouteMatch, Route } from 'react-router-dom';
import { getAllowedRoutes } from 'utils';
import { useSelector } from 'react-redux';
import { PrivateRoutesConfig } from 'config';
import { TopNav } from 'components/common';
//import { SideNav } from 'components/common';
import MapAllowedRoutes from 'routes/MapAllowedRoutes';
import Guides from 'views/GuidesPage/Guides';

function PrivateRoutes() {
	const match = useRouteMatch('/app');

	let allowedRoutes = [];
	const auth = useSelector((state) => state.auth)

	if (auth.isAuthenticated){
	    allowedRoutes = getAllowedRoutes(PrivateRoutesConfig, auth.permissions);
	    console.log(">>> Allowed routes:");
	    console.log(allowedRoutes);
	}else{
	    console.log("[PrivateRoutes] user is not authenticated!")
	    return <Redirect to="/login" />;
	}

	return (
		<Fragment>
			<TopNav routes={allowedRoutes} prefix={match.path} className='bg-white' />
			{/*<SideNav routes={allowedRoutes} prefix={match.path} className="bg-white" />*/}
			<MapAllowedRoutes routes={allowedRoutes} basePath='/app' isAddNotFound />
			<Route path='/app/help/guides/:id' component={Guides} />
		</Fragment>
	);
}

export default PrivateRoutes;